var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row",class:{ 'flex-col': _vm.isMobileScreen }},[_c('div',{staticClass:"box-card barging-table",class:{ 'mobile-view': _vm.isMobileScreen }},[_c('div',{staticClass:"barging-pagination"})]),_c('div',{staticClass:"timeline-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }